import React from 'react';
import PlacesAutocomplete from './PlacesAutocomplete';
import styles from '../../../styles/components/forms/BookingForm.module.css';

const LocationSection = ({ 
    formData, 
    errors, 
    isClicked, 
    isDarkMode, 
    onPlaceSelect, 
    onClearError,
    onErrorChange,
    getInputClassName 
}) => {
    return (
        <>
            {/* Pickup Location */}
            <div className="col-lg-6">
                <div className={`d-flex flex-column ${styles['form-field-container']}`}>
                    <label htmlFor="from" className={`${styles['form-labels']} ${isDarkMode ? styles['form-labels-dark'] : ''}`}>
                        FROM <span className="text-danger">*</span>
                    </label>
                    <PlacesAutocomplete
                        field="pickUpAddress"
                        placeholder="Pickup Location"
                        value={formData.pickUpAddress}
                        onChange={onPlaceSelect}
                        onClearError={onClearError}
                        onErrorChange={onErrorChange}
                        error={errors.pickUpAddress && isClicked}
                        isDarkMode={isDarkMode}
                        className={getInputClassName('pickUpAddress')}
                    />
                    {errors?.pickUpAddress && (
                        <div
                            className={`text-danger ${styles['error-message-container']}`}
                            style={{ minHeight: '20px' }}>
                            {errors.pickUpAddress}
                        </div>
                    )}
                    {errors?.pickUpAddress_pasteError && (
                        <div
                            className={`text-danger ${styles['error-message-container']}`}
                            style={{ minHeight: '20px' }}>
                            {errors.pickUpAddress_pasteError}
                        </div>
                    )}
                    {errors?.pickUpAddress_manipulationError && (
                        <div
                            className={`text-danger ${styles['error-message-container']}`}
                            style={{ minHeight: '20px' }}>
                            {errors.pickUpAddress_manipulationError}
                        </div>
                    )}
                </div>
            </div>

            {/* Dropoff Location */}
            <div className="col-lg-6">
                <div className={`d-flex flex-column ${styles['form-field-container']}`}>
                    <label htmlFor="to" className={`${styles['form-labels']} ${isDarkMode ? styles['form-labels-dark'] : ''}`}>
                        TO <span className="text-danger">*</span>
                    </label>
                    <PlacesAutocomplete
                        field="dropOffAddress"
                        placeholder="Dropoff Location"
                        value={formData.dropOffAddress}
                        onChange={onPlaceSelect}
                        onClearError={onClearError}
                        onErrorChange={onErrorChange}
                        error={errors.dropOffAddress && isClicked}
                        isDarkMode={isDarkMode}
                        className={getInputClassName('dropOffAddress')}
                    />
                    {errors.dropOffAddress && (
                        <div
                            className={`text-danger ${styles['error-message-container']}`}
                            style={{ minHeight: '20px' }}>
                            {errors.dropOffAddress}
                        </div>
                    )}
                    {errors?.dropOffAddress_pasteError && (
                        <div
                            className={`text-danger ${styles['error-message-container']}`}
                            style={{ minHeight: '20px' }}>
                            {errors.dropOffAddress_pasteError}
                        </div>
                    )}
                    {errors?.dropOffAddress_manipulationError && (
                        <div
                            className={`text-danger ${styles['error-message-container']}`}
                            style={{ minHeight: '20px' }}>
                            {errors.dropOffAddress_manipulationError}
                        </div>
                    )}
                </div>
            </div>
        </>
    );
};

export default LocationSection;
